import { useGetNewsList } from "../../../service/api";
import { PageHeader } from "../../../components/page-skeleton/PageHeader";
import { routes } from "../../../appRoutingHelpers";
import { SpinnerBlock } from "../../common/Spinner";
import { NewsListHeader } from "./NewsListHeader";
import { Table } from "../../../components/table-components/Table";
import { NewsListRow } from "./NewsListRow";
import { CardContainer } from "../../../components/page-skeleton/CardContainer";
import { Placeholder } from "../../../components/Placeholder";
import { PageWrapper } from "../../../components/page-skeleton/PageWrapper";
import { ButtonInternalLink } from "../../../components/NewButtons";
import { useSelector } from "react-redux";
import * as authSelectors from "../../auth/authSelectors";
import { useHandleFetchError } from "../../../error-handler";

export const NewsList = () => {
  const organizationKeyName = useSelector(
    authSelectors.selectedOrganizationKeyName
  );
  const { data: news, isLoading, error: getNewsListError } = useGetNewsList(
    organizationKeyName
  );

  useHandleFetchError(getNewsListError);

  if (isLoading || !news) {
    return <SpinnerBlock />;
  }

  return (
    <PageWrapper>
      <CardContainer>
        <PageHeader
          title="News list"
          subtitle="Create, manage and edit news. You can add news to your app homepages from the Homepages tab."
        >
          <ButtonInternalLink to={routes.newsNew(organizationKeyName)}>
            Add new
          </ButtonInternalLink>
        </PageHeader>
        {news.length === 0 ? (
          <Placeholder>
            No news created yet! Create your first and display it on the app
            homepage.
          </Placeholder>
        ) : (
          <Table>
            <NewsListHeader />
            <tbody>
              {news.map((n, index) => (
                <NewsListRow key={index} news={n} />
              ))}
            </tbody>
          </Table>
        )}
      </CardContainer>
    </PageWrapper>
  );
};
